import { Box, Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material';
import { StatusCheckboxOptionProps } from './StatusCheckboxOption.props';

const StatusCheckboxOption = ({ tooltip, checked, onChange, disabled, testId, label, icon }: StatusCheckboxOptionProps) => (
  <Tooltip title={tooltip} arrow placement="top">
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
          size="small"
          data-testid={testId}
          sx={{
            padding: '0px 8px',
            color: 'primary.main',
            '&.Mui-checked': { color: 'primary.main' },
          }}
        />
      }
      label={
        <Box display="flex" alignItems="center" gap={0.5}>
          {checked && icon}
          <Typography variant="body2" color={checked ? 'primary.main' : 'text.secondary'}>
            {label}
          </Typography>
        </Box>
      }
      sx={{ mr: 0 }}
    />
  </Tooltip>
);

export default StatusCheckboxOption;
